import { LoginPayload, loginSchema } from '../schema/LoginPayload.ts';
import { validateData } from '../utils/utils.ts';
import { api } from './client.ts';
import { loginUrl } from './constants.ts';

export async function postLogin(payload: LoginPayload) {
  const validatedData = validateData(loginSchema, payload, 'Login');
  return await api.post(loginUrl, validatedData, { skipAuthRedirect: true });
}
